var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIconMprFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16895 6.54508H7.19683L5.87227 0.924744L2.44 0.942033L1.16895 6.54508Z",
    fill: "#163029",
    stroke: "#163029",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0907 6.61621V19.8317L5.37686 20.5918C5.59783 20.7224 5.50591 21.0669 5.24969 21.065L3.04188 21.0509C2.79195 21.0497 2.6994 20.7167 2.91093 20.5822L4.09007 19.8317",
    fill: "#163029"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0907 6.61621V19.8317L5.37686 20.5918C5.59783 20.7224 5.50591 21.0669 5.24969 21.065L3.04188 21.0509C2.79195 21.0497 2.6994 20.7167 2.91093 20.5822L4.09007 19.8317",
    stroke: "#163029",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91211 6.61621V10.854",
    stroke: "#163029",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.444 10.9738C22.4551 10.9738 23.2747 11.8075 23.2747 12.8359V14.3746L23.8967 14.8594C24.4337 15.2775 24.7485 15.9262 24.7485 16.6146V21.0752L7.05893 20.9971L7.01864 16.6139C7.01298 15.9755 7.27865 15.3659 7.74766 14.9414L8.46345 14.294V12.9281C8.46345 11.8997 9.28311 10.9738 10.2942 10.9738H21.444Z",
    fill: "#163029",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8413 21.0752L21.8533 16.5998C21.8552 15.9396 22.1466 15.3147 22.649 14.8965L23.2748 14.3746",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95288 21.0099L9.96169 16.5979C9.96295 15.9364 9.67336 15.3095 9.17162 14.8882L8.46338 14.2939",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96436 17.6519H21.8413",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconMprFilled);
export default __webpack_public_path__ + "static/media/feature-icon-mpr-filled.3ae3e8e5.svg";
export { ForwardRef as ReactComponent };